import { DownOutlined } from '@ant-design/icons'
import { Button, Form, Space } from 'antd'
import type { ReactElement } from 'react'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function CoreDslFormDropdownButton({
  value,
  label,
  prefix,
}: {
  value?: string
  label: string
  prefix?: ReactElement
}) {
  return (
    <Form.Item label={label}>
      <Button className="w-full justify-between">
        <Space>
          {prefix}
          {value}
        </Space>
        <DownOutlined
          style={{
            marginLeft: 8,
            color: '#CFCFCF',
          }}
        />
      </Button>
    </Form.Item>
  )
}
